import { Injectable } from '@angular/core';
import { Personel, PersonelLogin } from '../models/Personel';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public user:PersonelLogin;

  constructor() { }

  public login(personelInfo: PersonelLogin){
    localStorage.setItem('personelInfo', JSON.stringify(personelInfo));
    //console.log(JSON.stringify(personelInfo));
    this.user = personelInfo;
  }

/*
  public loginTest(){
    localStorage.setItem('personelInfo', JSON.stringify({    
       access_token: "test",
       token_type: "test",
       user_name: "test Admin",
       user_role:"Admin"}));
  }*/
/*
  public isLoggedIn(){
    return localStorage.getItem('personelInfo') !== null;

  }
  public isPassChanged(){

    this.user = JSON.parse(localStorage.getItem('personelInfo'));

    //let user:PersonelLogin = JSON.parse(localStorage.getItem('personelInfo'));
    //console.log(user.first_login == "True");

    return this.user.first_login == "True";
  }*/

  public getLoginDetails(){

    return JSON.parse(localStorage.getItem('personelInfo'));
  }

  public logout(){
    localStorage.removeItem('personelInfo');
  }
  
  //personel role kontrolü
  roleMatch(allowedRoles): boolean {
   return true;
    /*
    var isMatch = false;
   var userRoles: string[] = JSON.parse(localStorage.getItem('userRoles'));
   allowedRoles.forEach(element => {
     if (userRoles.indexOf(element) > -1) {
       isMatch = true;
       return false;
     }
   });
   return isMatch;*/

 }

}
